module.exports = __webpack_public_path__ + "static/exterior-3-af46c8c17b22d550a4f6db4a6b1f69c2.jpg";